export const examAdminErrorPages = {
  notFoundPage: {
    subtitle: "Page not found",
    backToDashboard: "Back to Dashboard",
  },
  accessDenied: {
    subtitle: "This account is not allowed to access the current page",
    backToDashboard: "Back to Dashboard",
  },
  runtimeError: {
    title: "The admin portal encountered an unexpected error",
    subtitle: "Please refresh the page or go back to the dashboard and try again.",
  },
};
